import { render, staticRenderFns } from "./AccountRemovalRequest.vue?vue&type=template&id=0df661ef"
import script from "./AccountRemovalRequest.vue?vue&type=script&lang=js"
export * from "./AccountRemovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports